import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskAccountNumber',
  standalone: false
})
export class MaskAccountNumberPipe implements PipeTransform {
  transform(accountId: string): string {
    if (!accountId){
      return '';
    }
    const mask = accountId.slice(0, accountId.length-4);
    accountId = accountId.replace(mask, val => val.replace(/./g, 'x'))
    return `${accountId}`;
  }
}
